import React from 'react'
import cx from 'classnames'
import Loader from '../loader/Loader'
import './SectionLoader.scss'

export interface SectionSpinnerProps {
  message?: string
  className?: string
}

export const SectionLoader: React.FC<SectionSpinnerProps> = (props) => {
  const { message, className = '' } = props
  return (
    <div
      className={cx('section-loader', className)}
      data-testid="section-loader"
    >
      <Loader message={message} size="md" overlay={false} />
    </div>
  )
}

export default SectionLoader
